import { useEffect, useRef, useState } from 'react';
import jquery from 'jquery';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import {
    deleteMAGAH020,
    deleteMAGAI020,
    getMAGAH020,
    getMAGAI020,
    putMAGAH020,
    putMAGAI020,
} from '../../../services/Api';
import SideMenu from '../../../shared/components/SideMenu';
import 'summernote/dist/summernote-lite.min.js';
import 'summernote/dist/summernote-lite.min.css';
import 'summernote/dist/lang/summernote-ko-KR';

import { MENU_CENTER, MESSAGE } from '../../../shared/constants/app';
import { formatDateTime } from '../../../utils';

const MAGAI020 = () => {
    const { id } = useParams();
    const [data, setData] = useState({});
    const editorRef = useRef(null);

    useEffect(() => {
        jquery(editorRef.current).summernote({
            height: 300,
            lang: 'ko-KR',
            placeholder: '내용을 입력하세요...',
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture', 'video']],
                ['view', ['codeview']],
            ],
        });
    }, []);

    const { pathname } = useLocation();
    const pathKey = pathname.split('/')[1].split('-')[0];
    const navigate = useNavigate();

    useEffect(() => {
        if (pathKey === 'magai020') {
            getMAGAI020(id)
                .then(({ data }) => {
                    setData(data);
                    if (editorRef.current) {
                        jquery(editorRef.current).summernote('code', data?.replyMsg);
                    }
                })
                .catch((error) => console.log(error));
        } else if (pathKey === 'magah020') {
            getMAGAH020(id)
                .then(({ data }) => {
                    setData(data);
                    if (editorRef.current) {
                        jquery(editorRef.current).summernote('code', data?.replyMsg);
                    }
                })
                .catch((error) => console.log(error));
        }
    }, [id, pathKey]);

    const handleSave = () => {
        const isConfirmed = window.confirm('답변을 등록/수정하시겠습니까?');
        const updatePath = {
            magai020: putMAGAI020,
            magah020: putMAGAH020,
        };
        if (id && isConfirmed) {
            if (pathKey) {
                updatePath[pathKey]({
                    seq: id,
                    // replyFlag: 'Y',
                    // replyDate: moment().format('YYYY-MM-DDTHH:mm:ss.SSS'),
                    repContents: jquery(editorRef.current).summernote('code'),
                })
                    .then(() => {
                        window.alert('답변이 등록/수정되었습니다.');
                        // navigate('/magah010');
                    })
                    .catch((error) => {
                        console.log(error);
                        window.alert(MESSAGE.notify.updateError);
                    });
            }
        }
    };

    const handleDelete = () => {
        const isConfirmed = window.confirm(MESSAGE.confirm.delete);
        if (isConfirmed) {
            if (pathKey === 'magai020') {
                deleteMAGAI020(id)
                    .then(() => {
                        navigate('/magai010');
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else if (pathKey === 'magah020') {
                deleteMAGAH020(id)
                    .then(() => {
                        navigate('/magah010');
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        }
    };
    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_CENTER} />
                <div className="reply-qa-content content-right">
                    <Link className="link-to-delete" onClick={handleDelete}>
                        문의내역 삭제
                    </Link>
                    <div id="content-table">
                        <h1 className="title">이메일 문의</h1>
                        <table className="table-gray">
                            <tbody>
                                <tr>
                                    <th>
                                        <span>아이디</span>
                                    </th>
                                    <td colSpan={3}>{data?.memberID}</td>
                                </tr>
                                <tr>
                                    <th>
                                        <span>이름</span>
                                    </th>
                                    <td colSpan={3}>{data?.nameKor}</td>
                                </tr>
                                <tr>
                                    <th>
                                        <span> 치과명</span>
                                    </th>
                                    <td>{data?.bizCompany}</td>
                                </tr>
                                <tr>
                                    <th>
                                        <span>이메일</span>
                                    </th>
                                    <td>{data?.email}</td>
                                </tr>
                                <tr>
                                    <th>
                                        <span>연락처</span>
                                    </th>
                                    <td>{data?.telNo}</td>
                                </tr>
                                <tr>
                                    <th>
                                        <span>IP</span>
                                    </th>
                                    <td>{data?.regIP}</td>
                                </tr>
                                <tr>
                                    <th>
                                        <span>등록일</span>
                                    </th>
                                    <td>{formatDateTime(data?.addDate)}</td>
                                </tr>
                                <tr>
                                    <th>
                                        <span>제목</span>
                                    </th>
                                    <td>{data?.title}</td>
                                </tr>
                                <tr>
                                    <th>
                                        <span>내용</span>
                                    </th>
                                    <td>
                                        <div style={{ whiteSpace: 'pre-line' }}>{data?.contents}</div>
                                    </td>
                                </tr>
                                {data?.replyFlag === 'Y' && (
                                    <tr>
                                        <th>
                                            <span>답변등록일</span>
                                        </th>
                                        <td>{formatDateTime(data?.replyDate)}</td>
                                    </tr>
                                )}
                                <tr>
                                    <th className="require">
                                        <span>답변내용</span>
                                    </th>
                                    <td colSpan={3}>
                                        <div style={{ height: '300px' }} ref={editorRef}></div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="bottom-content">
                        <Link to={pathKey === 'magai020' ? '/magai010' : '/magah010'} className="button-back-to-list">
                            목록
                        </Link>
                        <Link onClick={handleSave} className="button-save">
                            답변등록/수정
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MAGAI020;
